<template>
  <div>
    <nav_list :index="4"></nav_list>

    <div class="scenic">


      <div class="left">
        <div class="itm">
            <el-cascader class="ipt" v-model="city_id" :placeholder="this.$lang('70387')" :options="options" clearable filterable
              @change="re()"></el-cascader>
        </div>

        <div class="itm" v-for="itm  in tabs" :key="itm.id">
          <div class="tit">
            {{ itm.strs.title }}
          </div>
          <div class="city">
            <div class="a" v-for="vo  in itm.sub" :key="vo.id" v-bind:class="{ act: tag_id == vo.id }"
              @click="clc_tab(vo.id)">{{ city_dis(vo.strs.title) }}
              <span v-if="tag_id == vo.id">x</span>
            </div>
          </div>

        </div>
      </div>

      <div class="right">
        <div class="tt6">
          <div class="bg" v-for="(itm, n) in list.data" :key="n">
            <div class="cover">
              <img :src="itm.strs.cover" alt="">
            </div>
            <div class="info">
              <div class="title1">

                {{ itm.strs.title }}
              </div>
              <div class="desc">
                <div class="l1">
                  <div class="drow">
                    <span class="drl"><i class="el-icon-add-location"></i> {{ $lang(70380) }} :</span>
                    <span> <el-tag type="success">
                        {{ itm.strs.city }}

                      </el-tag>

                    </span>
                  </div>
                  <div class="drow">
                    <span class="drl"> <i class="el-icon-location-information"></i> {{ $lang(70381) }} :</span>
                    <span> {{ itm.address }}</span>
                  </div>
                  <div class="drow">
                    <span class="drl"><i class="el-icon-time"></i>  {{ $lang(70382) }} :</span>
                    <span> {{ itm.open_time }}</span>
                  </div>
                  <div class="drow">
                    <el-tag type="warning">
                      {{ ps[itm.china_cate_id].strs.title }}

                    </el-tag>
                    <el-tag type="warning">
                      {{ ps[itm.china_tag_id].strs.title }}

                    </el-tag>
                  </div>
                </div>

                <div class="l2">
                  <el-button @click="jump('/shop/info?id=' + itm.id)" icon="el-icon-search" plain type="success"> {{
                      $lang(70383)
                  }}</el-button>
                </div>
              </div>





            </div>

          </div>

          <el-empty :description="$lang(70388)" v-if="(list.data.length == 0)"></el-empty>
        </div>

        <div style=" text-align: right;padding: 10px;">
          <el-pagination background layout="prev, pager, next" :current-page="list.current_page"
            :page-size="list.per_page" :total="list.total" @current-change="change_page">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>

</template>


<script>

import nav_list from '../index/nav_list.vue';
export default {
  name: "index",
  data() {
    return {
      list: [],
      first_load: 1,
      list_page: 1,
      tabs: [],
      ps: {},
      tag_id: 0,
      city_id: 0,
      options: [],
    };
  },
  methods: {
    clc_tab(tag_id) {
      if (this.tag_id == tag_id) {
        this.tag_id = 0
      } else {
        this.tag_id = tag_id
      }
      this.list_page = 1
      this.f5()
    },
    change_page(e) {
      this.list_page = e
      this.f5()
    },
    re(){
      this.list_page = 1
      this.f5()
    },
    f5() {

      // this.list_page += inc
      this.get("/shop/index", { page: this.list_page, n: 12, first_load: this.first_load, tag_id: this.tag_id, city_id: this.city_id }).then((e) => {
        this.first_load = 1
        this.list = e.list
        if (e.tabs) {
          this.tabs = e.tabs
        }
        if (e.ps) {
          this.ps = e.ps
        }
        if (e.city) {
          this.options = e.city
        }


      });
    },


  },
  mounted() {
    this.f5()
  },
  components: {  //注册
    nav_list,
  }

};
</script>


<style scoped>
.scenic {
  display: flex;
  width: 95vw;
  margin: auto;
  margin-top: 2vh;
}

.left {
  box-shadow: 0px 4px 16px 1px rgb(0 0 0 / 6%);
  width: 24vw;
  min-height: 70vh;
}

.left .itm {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 100%;
  border-bottom: 1px solid #f6f8fa;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  height: 78px;
  padding: 0 16px;
  background: #fff;
  cursor: pointer;

}

.left .itm .tit {
  color: #333333;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0px;
  margin-bottom: 6px;
}

.left .itm .city {
  color: #999999;
  font-size: 14px;
  letter-spacing: 0px;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.left .itm .city .a {
  display: block;
  margin: 0 8px 0 0;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  color: #999999;
}

.left .itm .city .act {
  color: #1c5098;
  font-weight: bold;
}

.right {
  margin-left: 1vw;
  width: 74vw;
}

.tt6 {
  margin: 0 auto;
  width: 73.5vw;
  min-height: 654px;


}

.bg {
  border: 1px solid #eee;
  flex: 0 0 100%;
  cursor: pointer;
  margin-bottom: 10px;
  box-shadow: 0 0 14px 4px #eee;
  border-radius: 5px;
  overflow: hidden;
  max-height: 180px;
  display: flex;
  /* align-items: center; */
  padding: 10px;
}

.bg .cover {
  flex: 0 0 30%;

}

.bg .cover img {
  border-radius: 5px;
  width: 80%;

  box-shadow: 0 0 14px 4px #eee;
}

.bg .info {
  flex: 0 0 70%;

}

.bg .info .desc {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  align-items: center;
}

.bg .info .desc .drl {
  color: #6d6d6d;
  margin-right: 10px;
}

.bg .info .desc .drow {
  margin-top: 10px;
}

.bg .title1 {

  font-size: 18px;
  color: #333333;
  font-weight: bold;



}
</style>



// WEBPACK FOOTER //
// src/pages/shop/index.vue